/* ===========================================================================
   MM — PROJET / DÉROULÉ DES ÉTAPES
   ---------------------------------------------------------------------------
   L'étape active se lit au scroll : celle dont le bloc traverse la bande
   centrale de la fenêtre s'allume, et le visuel sticky d'en face bascule sur
   le média du même index. Tout le mouvement est en CSS (.is-active) — ici on
   ne fait que poser la classe.

   L'observation se fait par IntersectionObserver avec une « ligne de
   lecture » : rootMargin réduit la zone d'intersection à une bande entre 35 %
   et 45 % de la hauteur de fenêtre. Une étape qui la recouvre devient
   l'active ; quand plusieurs la recouvrent (étapes courtes), la dernière
   entrée gagne — c'est celle vers laquelle on se dirige.
   =========================================================================== */

(function () {
	'use strict';

	if (window.__mmProjetEtapes) return;
	window.__mmProjetEtapes = true;

	function init(root) {
		var sections = (root || document).querySelectorAll('[data-etapes]');
		Array.prototype.forEach.call(sections, function (section) {
			if (section.dataset.mmEtapesReady === '1') return;
			section.dataset.mmEtapesReady = '1';

			var etapes = section.querySelectorAll('[data-etape]');
			var medias = section.querySelectorAll('[data-etape-media]');
			if (etapes.length < 2) return;

			function activate(index) {
				Array.prototype.forEach.call(etapes, function (el, i) {
					el.classList.toggle('is-active', i === index);
				});
				Array.prototype.forEach.call(medias, function (el, i) {
					el.classList.toggle('is-active', i === index);
				});
			}

			var observer = new IntersectionObserver(function (entries) {
				entries.forEach(function (entry) {
					if (!entry.isIntersecting) return;
					var index = Array.prototype.indexOf.call(etapes, entry.target);
					if (index !== -1) activate(index);
				});
			}, {
				/* La bande de lecture : 35 % → 45 % de la fenêtre. Elle est
				   posée au-dessus du centre pour que la dernière étape puisse
				   devenir active même quand le bas de page l'empêche de monter
				   jusqu'au milieu de l'écran. */
				rootMargin: '-35% 0px -55% 0px'
			});

			Array.prototype.forEach.call(etapes, function (el) {
				observer.observe(el);
			});
		});
	}

	/* L'éditeur de thème recharge des sections entières : on ré-initialise. */
	document.addEventListener('shopify:section:load', function (event) {
		init(event.target);
	});

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () { init(); });
	} else {
		init();
	}
})();
